import {environment} from '../../../environments/environment';

/** Auxiliary 'DATE_FORMAT' variable.' */
export const DATE_FORMAT = 'MM/DD/YYYY';
/** Auxiliary 'FULL_YEAR_FORMAT' variable.' */
export const FULL_YEAR_FORMAT = 'YYYY';
/** Auxiliary 'DATE_FORMAT_URL' variable.' */
export const DATE_FORMAT_URL = 'DD-MMM-YYYY';
/** Auxiliary 'TIME_FORMAT' variable.' */
export const TIME_FORMAT = 'HH:mm a';
/** Auxiliary 'TIME_FORMAT_ULTIMATE' variable.' */
export const TIME_FORMAT_ULTIMATE = 'HH:mm:ss';
/** Auxiliary 'DATETIME_FORMAT' variable.' */
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
/** Auxiliary 'CODE_DATE' variable.' */
export const CODE_DATE = 'YYYYMMDD';
/** Auxiliary 'DATE_TIME_FORMAT' variable.' */
export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm';

/** Auxiliary 'MDM_DATE_FORMATS' variable.' */
export const MDM_DATE_FORMATS = {
	parse: {
		dateInput: DATE_FORMAT,
	},
	display: {
		dateInput: DATE_FORMAT,
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: DATE_FORMAT,
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

/** Auxiliary 'API_DATE_FORMAT' variable.' */
export const API_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
/** Auxiliary 'API_DAY_FORMAT' variable.' */
export const API_DAY_FORMAT = 'YYYY-MM-DD';

// TODO: remove - get it from API
/** Auxiliary 'DEV_API_TIMEZONE' variable.' */
const DEV_API_TIMEZONE = 'Europe/London';
/** Auxiliary 'PROD_API_TIMEZONE' variable.' */
const PROD_API_TIMEZONE = 'America/New_York';
/** Auxiliary 'API_TIMEZONE' variable.' */
export const API_TIMEZONE = environment.envName === 'prod' ? PROD_API_TIMEZONE : DEV_API_TIMEZONE;

/** Auxiliary 'today' variable.' */
export const today = new Date();
/** Auxiliary 'yesterday' variable.' */
export const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
